import React, {useState} from 'react';
import colours from 'styles/colours';

const containerStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 12px 0 20px',
    height: 62,
    background: colours.background.banner,
    borderBottom: `2px solid ${colours.border.primary.highlight}`,
    flexShrink: 0,
};

const titleStyles = {
    fontSize: 16,
    fontWeight: 600,
    color: colours.font.contrast,
    letterSpacing: '0.01em',
};

const closeButtonStyles = (focused) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    background: 'transparent',
    border: 'none',
    borderRadius: 6,
    color: colours.font.contrast,
    cursor: 'pointer',
    padding: 0,
    transition: 'background 0.15s ease',
    outline: focused ? `2px solid ${colours.font.contrast}` : 'none',
    outlineOffset: focused ? '2px' : '0',
});

const closeIconStyles = {width: 14, height: 14};

export default function PanelHeader({onClose, closeButtonRef}) {
    const [focused, setFocused] = useState(false);
    const [hovered, setHovered] = useState(false);
    return (
        <div style={containerStyles}>
            <span id="side-panel-title" style={titleStyles}>Applications</span>
            <button
                ref={closeButtonRef}
                onClick={onClose}
                aria-label="Close applications menu"
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                style={{
                    ...closeButtonStyles(focused),
                    background: hovered ? colours.background.hoverOverlayOnDark : 'transparent',
                }}
            >
                <img src="/images/icons/close.svg" alt="" aria-hidden="true" style={closeIconStyles}/>
            </button>
        </div>
    );
}

